import React from 'react';
import {func, array, string, object} from 'prop-types';
import styles from './mobileNavSearchResults.scss';
import {createFragmentContainer, graphql} from 'react-relay';
import get from 'lodash.get';
// TODO: https://1stdibs.atlassian.net/browse/MW-489
import {SECTIONS_BY_TYPE, createSearchLinkPath} from './mobileNavSearchResultsUtils';

function Results(props) {
    const {title, urlSection} = SECTIONS_BY_TYPE[props.type] || {};
    return (
        <div className={styles.results}>
            <span className={styles.title}>{title}</span>
            {props.items.map(result => {
                const {term, urlLabel} = result;
                const searchResultUrl = createSearchLinkPath({term, urlSection, urlLabel});
                return (
                    <div key={term}
                        onClick={() => props.handleNavigateAction({path: searchResultUrl})}
                        className={styles.item}
                    >
                        {term}
                    </div>
                );
            })}
        </div>
    );
}

Results.defaultProps = {
    items: []
};

Results.propTypes = {
    handleNavigateAction: func.isRequired,
    type: string.isRequired,
    items: array
};

export function MobileNavSearchResults(props) {
    const suggestions = (get(props, 'searchSuggestions.suggestions') || [])
        .filter(suggestion => suggestion.terms.length);

    return (
        <div>
            {suggestions.map(suggestion => {
                const {type, terms} = suggestion;
                return <Results key={type} type={type} items={terms} handleNavigateAction={props.handleNavigateAction} />;
            })}
        </div>
    );
}

MobileNavSearchResults.propTypes = {
    searchSuggestions: object.isRequired,
    handleNavigateAction: func.isRequired
};

export default createFragmentContainer(MobileNavSearchResults,
    graphql`
        fragment MobileNavSearchResults_searchSuggestions on SearchSuggestion {
            suggestions {
                type
                terms {
                    term
                    urlLabel
                }
            }
        }
    `
);



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavSearchResults/MobileNavSearchResults.jsx